import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {ProtocolDetailsBySerialCodeDto} from '../../dtos/protocolDetailsBySerialCodeDto';
import {UnpackProtocolDto} from '../../dtos/unpackProtocolDto';
import {SerialCodeInfoDto} from '../../dtos/serialCodeInfoDto';

@Injectable({
    providedIn: 'root'
})
export class ProtocolAdminService {

    constructor(private httpClient: HttpClient) {
    }

    public findLatestUsageForSerialCodes(serialCodes: string[]): Observable<SerialCodeInfoDto[]> {
        const httpParams = new HttpParams().set('serialCodes', serialCodes.toString());
        return this.httpClient.get<any>(environment.apiUrl + 'api/protocols/admin/v1/findBySerialCodes', {params: httpParams})
            .pipe(map((serialCodeInfoDtos: SerialCodeInfoDto[]) => {
                return serialCodeInfoDtos;
            }));
    }

    public findLatestUsageForSerialCodeAndEmail(serialCode: string, email: string): Observable<SerialCodeInfoDto> {
        const httpParams = new HttpParams()
                .set('serialCode', serialCode.toString())
                .set('email', email.toString());
        return this.httpClient.get<any>(environment.apiUrl + 'api/protocols/admin/v1/findBySerialCodeAndEmail', {params: httpParams})
            .pipe(map(serialCodeInfoDto => {
                return serialCodeInfoDto;
            }));
    }

    public getProtocolActivityDetailsBySerialCode(serialCode: string): Observable<ProtocolDetailsBySerialCodeDto[]> {
        const httpParams = new HttpParams().set('serialCode', serialCode.toString());

        return this.httpClient.get<any>(environment.apiUrl + 'api/protocols/admin/v1/findDetailsBySerialCode', {params: httpParams})
            .pipe(map((protocolDetailsList: ProtocolDetailsBySerialCodeDto[]) => {
                return protocolDetailsList;
            }));
    }

    public unpackProtocol(protocolCode: string): Observable<UnpackProtocolDto> {
        const httpParams = new HttpParams().set('protocolCode', protocolCode.toString());
        return this.httpClient.get<any>(environment.apiUrl + 'api/protocols/admin/v1/unpackProtocol', {params: httpParams})
            .pipe(map(resultsData => {
                return new UnpackProtocolDto().deserialize(resultsData);
            }));
    }
}
